export const EN_QUESTION_CODE_STRINGS = {
  QUESTION_CODE: '{count, plural, one {Question Code} other {Question Codes}}',
  QUESTION_CODE_ENTITY_NAME: 'Question Code',
  QUESTION_CODE_LABEL: 'Question Code',
  QUESTION_CODE_NAME_LABEL: 'Name',
  QUESTION_CODE_NAME_HINT: 'Short name for the question code.',
  QUESTION_CODE_CODE_LABEL: 'Code',
  QUESTION_CODE_CODE_HINT: 'Actual question code',
  QUESTION_CODE_CODE_SET_LABEL: 'Set',
  QUESTION_CODE_CODE_SET_HINT:
    'Choose the code system (e.g., LOINC, League, ISO Country Code, or Custom). This determines the set of codes available when configuring a question.',
  QUESTION_CODE_QA_BANNER_TITLE: 'These configurations are under development.',
  QUESTION_CODE_QA_BANNER_DESCRIPTION:
    'Please do not use to create the question for questionnaire.',
  QUESTION_CODE_CODE_SET_LOINC: 'LOINC',
  QUESTION_CODE_CODE_SET_LEAGUE: 'LEAGUE',
  QUESTION_CODE_CODE_SET_CUSTOMER_CUSTOM: 'CUSTOMER CUSTOM',
  QUESTION_CODE_CODE_SET_ISO: 'ISO Country Code',
};
